/* eslint unicode-bom: ["error", "always"] */
import React, { Component } from 'react';
import { Button, Row, Col } from "reactstrap";
import Styles from "./Home.module.css";
import MainContainer from './Home/MainContainer';
import Main from './Home/MainContainer/Cards/Main';
import HowItWorks from './Home/MainContainer/Cards/HowItWorks';
import ForContractors from './Home/MainContainer/Cards/ForContractors';
import ForHomeowners from './Home/MainContainer/Cards/ForHomeowners';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../context/User';
import Social from './Home/Social';

export class Home extends Component {
  static displayName = Home.name;
  static contextType = UserContext;
  defautActiveContent = <Main />

  constructor(props) {
    super(props);

    this.state = {
      activeContent: this.defautActiveContent
    };
  }

  render() {
    if (this.context.isContractor()) {
      return <Navigate to="/my-work" replace />;
    }

    return (
      <div className={`mt-3 ${Styles.contentHome}`}>
        <div className={Styles.greeting}>
          {
            this.state.activeContent === this.defautActiveContent ?
              <Row>
                <Col xs="12" className={`text-center ${Styles.contentMenuColumn}`}>
                  <Button color="link" className='p-0' onClick={() => { this.setState({ activeContent: <HowItWorks /> }) }}>
                    <span className={Styles.linkButton}>How it Works</span>
                  </Button>
                  <Button color="link" className='p-0' onClick={() => { this.setState({ activeContent: <ForHomeowners /> }) }}>
                    <span className={Styles.linkButton}>For Homeowners</span>
                  </Button>
                  <Button color="link" className='p-0' onClick={() => { this.setState({ activeContent: <ForContractors /> }) }}>
                    <span className={Styles.linkButton}>For Contractors</span>
                  </Button>
                </Col>
              </Row>
              :
              <Row>
                <Col xs="12" className={`text-start`}>
                  <Button color="link" className='p-0' onClick={() => { this.setState({ activeContent: this.defautActiveContent }) }}>
                    <span className={Styles.linkButton}>&lt; Back</span>
                  </Button>
                </Col>
              </Row>
          }
          <Row>
            <Col sm="12">
              <MainContainer className={Styles.mainContainer}>
                {this.state.activeContent}
              </MainContainer>
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col sm="12">
              <Social/>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
